import * as React from "react";
import moment from "moment";
import axios from "axios";
import Linkify from "linkify-react";
import "linkify-plugin-mention";
import "linkify-plugin-hashtag";
import Weather from "./weather";
import PostMenu from "./postMenu";
import FilePicker from "./filePicker";
import ScrollButton from "./ScrollButton";
import { IconContext } from "react-icons";
import { BiMailSend } from "react-icons/bi";
import { BiSend } from "react-icons/bi";
import { MdOutlineMailOutline } from "react-icons/md";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "@sweetalert2/themes/dark";
import { renderToString } from "react-dom/server";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { UserContext } from "./user_Context";
import { createRoot } from "react-dom/client";
import Markdown, { defaultUrlTransform } from "react-markdown";
import remarkBreaks from "remark-breaks";
import rehypeRaw from "rehype-raw";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { a11yDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { url } from "inspector";

const Comments = (props: { table: string; ip: string; comments: any }) => {
  var strURL = "https://api.chonerman.com/commenter";
  var strURLImg = "https://api.chonerman.com/handleImage";
  var infoURL = "https://api.chonerman.com/getURLInfo";
  const tblName = props.table;
  const [posts, setPosts] = React.useState([]);
  const [name, setName] = React.useState("");
  const [body, setBody] = React.useState("");
  const [lat, setLat] = React.useState("0");
  const [long, setLong] = React.useState("0");
  const [loading, setLoading] = React.useState(true);
  const [isImage, setIsImage] = React.useState(false);
  const pbRef = React.createRef<HTMLDivElement>();
  const { user, setUser } = React.useContext(UserContext);
  var postingName = <></>;
  var postCardDiv = "";

  const getCoords = async (p0?: () => void) => {
    const geolocAPI = navigator.geolocation;
    const pos = await new Promise(() => {
      geolocAPI.getCurrentPosition(success, error);
      function success(pos: any) {
        setLat(pos.coords.latitude);
        setLong(pos.coords.longitude);
      }
      function error(err: any) {
        console.error(err.code + " --- " + err.Message);
      }
    });
    return pos;
  };

  const showToast = async (msg: string, msgType: number) => {
    const myToast = Swal.mixin({
      toast: true,
      position: "top-right",
      iconColor: "black",
      customClass: {
        popup: "colored-toast",
      },
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    switch (msgType) {
      case 1:
        //toast.success(msg);
        myToast.fire({
          icon: "success",
          title: "Success",
          html: msg!,
        });
        break;
      case 2:
        //toast.error(msg);
        myToast.fire({
          icon: "error",
          title: "Error",
          html: msg!,
        });
        break;
      case 3:
        //toast.warn(msg);
        myToast.fire({
          icon: "warning",
          title: "Warning",
          html: msg!,
        });
        break;
      case 4:
        //toast.info(msg);
        myToast.fire({
          icon: "info",
          title: "Info",
          html: msg!,
        });
        break;
    }
  };

  const getURLInfo = async function (href: any) {
    try {
      var response = await axios.post(infoURL, { url: href });
      return response.data.body;
    } catch (error) {
      console.error(error);
    }
  };

  //https://linkify.js.org/docs/options.html#render
  const RenderLink = ({ attributes, content }: any) => {
    const [URLInfo, setURLInfo] = React.useState();
    const [URLIcon, setURLIcon] = React.useState();
    const { href, ...props } = attributes;
    //call lambda

    React.useEffect(() => {
      const fetchInfo = async () => {
        var urlInfo = await getURLInfo(href);
        if (urlInfo === undefined) {
          console.log("No link info fetched: " + href);
        } else {
          setURLInfo(urlInfo.title);
          setURLIcon(urlInfo.iconLink);
          scrollToElement();
        }
      };
      fetchInfo();
    });

    if (URLInfo === undefined || URLInfo === null) {
      return (
        <span className="post-link-box">
          <a href={href} {...props}>
            {content}
          </a>
        </span>
      );
    } else {
      return (
        <span className="post-link-box">
          <a href={href} {...props}>
            <img className="post-link-icon" alt={URLInfo} src={URLIcon} />
            {URLInfo}
          </a>
        </span>
      );
    }
  };

  const LinkifyOptions = {
    render: {
      url: RenderLink,
    },
    truncate: 20,
    target: "_blank",
    rel: "noopener",
    formatHref: {
      mention: (href: string) => "https://x.com" + href,
      hashtag: (href: string) =>
        "https://twitter.com/hashtag/" + href.substr(1),
    },
  };

  const MyLoader = () => (
    <svg
      className="loader"
      version="1.1"
      id="L5"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 0 0"
    >
      <circle fill="blue" stroke="none" cx="6" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 15 ; 0 -15; 0 15"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill="white" stroke="none" cx="30" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 10 ; 0 -10; 0 10"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill="red" stroke="none" cx="54" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
  );

  // enable/disable button
  const toggleSend = (way: boolean) => {
    var txtMsg = document.getElementById("txtMsg") as HTMLInputElement;
    var txtName = document.getElementById("txtName") as HTMLInputElement;
    var btnSend = document.getElementById("btnSend") as HTMLInputElement;
    if (way === true) {
      txtMsg.disabled = true;
      txtName.disabled = true;
      btnSend.disabled = true;
    } else {
      txtMsg.disabled = false;
      txtMsg.value = "";
      txtName.disabled = false;
      btnSend.disabled = false;
      handleBodyInput();
    }
  };

  // Post
  const addPosts = async (
    tblName: string,
    name: string,
    family_name: string | null,
    handle: string | null,
    avatar: string | null,
    email: string | null,
    body: string,
    ip: string,
    lat: string,
    long: string,
    weather: object
  ) => {
    console.log(JSON.stringify(body));
    let pageBottom = document.querySelector("#page-bottom") as HTMLElement;
    toggleSend(true);
    Swal.fire({
      html: "Sending post from " + name + "...",
      iconHtml: renderToString(<BiMailSend />),
      toast: true,
      iconColor: "green",
      timer: 8000,
      timerProgressBar: true,
      position: "bottom-end",
      onBeforeOpen() {
        Swal.showLoading();
      },
      onAfterClose() {
        Swal.hideLoading();
      },
    });

    const requestOptions = {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "X-API-Key": "1m7eHtTtkU83F8lBV81D6alTgJXF0A8o7Apfqa8r",
        "Content-Type": "application/json",
      },
    };

    try {
      var queryString = {
        mybody: {
          tblName: tblName,
          name: name,
          family_name: family_name,
          handle: handle,
          avatar: avatar,
          email: email,
          body: body,
          ip: ip,
          lat: lat,
          long: long,
          weather: weather,
        },
      };
      //console.log(queryString);
      var response = await axios.post(strURL, queryString, requestOptions);
      //console.log(response);
      if (response.status === 200) {
        console.log("Post from: " + name, "💾");
        setBody("");
        toggleSend(false);
        pageBottom.scrollIntoView({
          behavior: "smooth",
        });
        Swal.close();
        return response.data;
      } else {
        console.error("Response Error: " + response.data, "💥");
        showToast("Response Error: " + response.data, 2);
        toggleSend(false);
        return;
      }
    } catch (error) {
      console.error("Error: " + error, "💥");
      showToast("Error: " + error, 2);
      toggleSend(false);
    }
  };

  // Post with image
  const addPostsImg = async (
    tblName: string,
    name: string,
    family_name: string | null,
    handle: string | null,
    avatar: string | null,
    email: string | null,
    body: string,
    ip: string,
    lat: string,
    long: string,
    weather: object,
    imgName: string,
    imgContent: any
  ) => {
    let pageBottom = document.querySelector("#page-bottom") as HTMLElement;
    toggleSend(true);
    Swal.fire({
      html: "Sending post with image from " + name + "...",
      iconHtml: renderToString(<BiMailSend />),
      toast: true,
      iconColor: "green",
      timer: 8000,
      timerProgressBar: true,
      position: "bottom-end",
      onBeforeOpen() {
        Swal.showLoading();
      },
      onAfterClose() {
        Swal.hideLoading();
      },
    });

    const requestOptions = {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "X-API-Key": "1m7eHtTtkU83F8lBV81D6alTgJXF0A8o7Apfqa8r",
        "Content-Type": "application/json",
      },
    };
    const requestOptionsImg = {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "X-API-Key": "1m7eHtTtkU83F8lBV81D6alTgJXF0A8o7Apfqa8r",
      },
    };

    try {
      var imgString = {
        body: {
          imgName: imgName,
          imgContent: imgContent,
        },
      };
      var resImg = await axios.post(strURLImg, imgString, requestOptionsImg);

      if (resImg.data.statusCode === 200) {
        console.log(resImg.data.body);
        const ETag = resImg.data.body;

        // Call post to include ETag
        var queryString = {
          mybody: {
            tblName: tblName,
            name: name,
            family_name: family_name,
            handle: handle,
            avatar: avatar,
            email: email,
            body: body,
            ip: ip,
            lat: lat,
            long: long,
            weather: weather,
            ETag: ETag,
          },
        };

        var response = await axios.post(strURL, queryString, requestOptions);

        if (response.status === 200) {
          console.log("Post from: " + name, "💾");
          setBody("");
          toggleSend(false);
          setIsImage(false);
          pageBottom.scrollIntoView({
            behavior: "smooth",
          });
          Swal.close();
          return response.data;
        } else {
          console.error("Response Error: " + response.data, "💥");
          showToast("Response Error: " + response.data, 2);
          toggleSend(false);
          return;
        }
      } else {
        console.error("Response Error: " + resImg.data.body.message, "💥");
        showToast("Response Error: " + resImg.data.body.message, 2);
        return;
      }
    } catch (error) {
      console.error("Error: " + error, "💥");
      showToast("Error: " + error, 2);
      toggleSend(false);
    }
  };

  //handle enter key
  const handleEnterKey = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  // Handle post button click
  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    getCoords();
    var txtMsg = document.getElementById("txtMsg") as HTMLTextAreaElement;
    var txtName = document.getElementById("txtName") as HTMLInputElement;
    var valFamilyName = user.family_name;
    var valAvatar = document.querySelector("#post_avatar") as HTMLImageElement;
    var valEmail = user.email;
    var valHandle = user.handle;
    var valLocName = document.querySelector("#locName") as HTMLSpanElement;
    var valTemp = document.querySelector("#temp") as HTMLSpanElement;
    var valWeather = document.querySelector("#weather") as HTMLSpanElement;
    var valHumidity = document.querySelector("#humidity") as HTMLSpanElement;
    var valPressure = document.querySelector("#pressure") as HTMLSpanElement;
    var valWind = document.querySelector("#wind") as HTMLSpanElement;
    var valIcon = document.querySelector("#weatherIconId") as HTMLSpanElement;
    var valSunrise = document.querySelector("#sunrise") as HTMLSpanElement;
    var valSunset = document.querySelector("#sunset") as HTMLSpanElement;
    //image
    var objImage = document.querySelector(
      "#image-selected"
    ) as HTMLImageElement;
    //setName(txtName.value);
    //setBody(txtMsg.value);
    const objWeather = {
      temp: valTemp.textContent,
      location: valLocName.textContent,
      weather: valWeather.textContent,
      humidity: valHumidity.textContent,
      pressure: valPressure.textContent,
      wind: valWind.textContent,
      icon: parseFloat(valIcon.innerHTML),
      sunrise: valSunrise.textContent,
      sunset: valSunset.textContent,
    };
    if (txtMsg.value && txtName.value) {
      if (objImage === null) {
        addPosts(
          tblName,
          txtName.value,
          valFamilyName,
          valHandle,
          valAvatar ? valAvatar.src : "",
          valEmail,
          txtMsg.value,
          props.ip,
          lat,
          long,
          objWeather
        );
      } else {
        setIsImage(true);
        addPostsImg(
          tblName,
          txtName.value,
          valFamilyName,
          valHandle,
          valAvatar ? valAvatar.src : "",
          valEmail,
          txtMsg.value,
          props.ip,
          lat,
          long,
          objWeather,
          objImage.alt,
          objImage.src
        );
      }
    } else if (txtMsg.value && txtName.value === "") {
      showToast("You didn't enter your name!", 3);
    } else if (txtMsg.value === "" && txtName.value) {
      showToast("You didn't enter a message!", 3);
    } else if (txtMsg.value === "" && txtName.value === "") {
      showToast("You didn't enter your name or a message!", 3);
    }
  };

  const handleBodyInput = () => {
    var bodyInput = document.querySelector("#txtMsg") as HTMLInputElement;
    var btnSend = document.querySelector("#btnSend") as HTMLInputElement;
    if (bodyInput.value.length !== 0) {
      btnSend.classList.add("showSendBtn");
      btnSend.classList.remove("hideSendBtn");
    } else {
      btnSend.classList.remove("showSendBtn");
      btnSend.classList.add("hideSendBtn");
    }
  };

  const handleNameClick = (element: any) => {
    Swal.fire({
      title:
        element.name +
        " " +
        (element.family_name !== null ? element.family_name : ""),
      html: renderToString(
        <>
          {element.handle ? (
            <>
              <div>{element.handle}</div>
            </>
          ) : (
            <></>
          )}
          {element.email ? (
            <>
              <div className="mailIcon">
                <MdOutlineMailOutline />
              </div>{" "}
              {element.email}
            </>
          ) : (
            <></>
          )}
        </>
      ),
      iconHtml: renderToString(
        element.avatar ? (
          <img
            className="post_avatar_click"
            alt={element.name}
            src={element.avatar}
          />
        ) : (
          <></>
        )
      ),
    });
  };

  const createInputNameBlock = (avatar: string | null) => {
    var nameBlock;
    if (avatar !== null) {
      nameBlock = (
        <>
          <img
            id="post_avatar"
            className="input-avatar"
            src={user.picture || ""}
            alt="avatar"
          />
          <input
            type="text"
            className="inpName_hide"
            id="txtName"
            value={user.given_name || ""}
          />
        </>
      );
    } else {
      nameBlock = (
        <input
          title="Handle"
          type="text"
          placeholder="name"
          className="inpName"
          id="txtName"
          value={user.given_name || undefined}
        />
      );
    }
    return nameBlock;
  };

  const PBBottom = React.forwardRef((props, ref) => {
    return (
      <div ref={pbRef} id="page-bottom">
        &nbsp;
      </div>
    );
  });

  const scrollToElement = () => {
    let contentHeight = window.innerHeight + Math.round(window.scrollY);
    let documentHeight = document.body.offsetHeight;
    if (contentHeight < documentHeight) {
      pbRef.current?.scrollIntoView({
        behavior: "smooth",
      });
    } else {
      console.log("scroll bottom");
    }
  };

  // USEEFFECT
  React.useEffect(() => {
    getCoords();
    if (posts.length === props.comments.length) {
      //console.log("no new comments: " + posts.length + " | " + props.comments.length);
    } else {
      setPosts(props.comments);
      scrollToElement();
    }

    setLoading(false);
  }, [props.comments]);

  // return components
  return (
    <>
      {loading ? (
        MyLoader()
      ) : posts ? (
        //<Linkify options={LinkifyOptions}>
        <>
          <PhotoProvider>
            <div className="post-cont">
              {posts.map((post: any, key, elements: any) => {
                var postBody = (
                  <Markdown
                    remarkPlugins={[remarkBreaks]}
                    rehypePlugins={[rehypeRaw]}
                    components={{
                      code(props) {
                        const { children, className, node, ref, ...rest } =
                          props;
                        const match = /language-(\w+)/.exec(className || "");
                        return match ? (
                          <SyntaxHighlighter
                            {...rest}
                            PreTag="div"
                            style={a11yDark}
                            language={match[1]}
                          >
                            {String(children).replace(/\n$/, "")}
                          </SyntaxHighlighter>
                        ) : (
                          <code {...props} className={className}>
                            {children}
                          </code>
                        );
                      },
                      p: (props) => (
                        <Linkify options={LinkifyOptions}>
                          {props.children}
                        </Linkify>
                      ),
                    }}
                  >
                    {post.body.replace(/\n/gi, "\n")}
                  </Markdown>
                );

                /* var postBody = (
                  <Linkify options={LinkifyOptions}>{tmpPostBody}</Linkify>
                ); */

                var postDT = moment(post.postdt).startOf("minute").fromNow();
                if (key > 0) {
                  var prevPost = elements[key - 1];
                } else {
                  var prevPost = {} as any;
                }
                if (key < elements.length - 1) {
                  var nextPost = elements[key + 1];
                } else {
                  var nextPost = {} as any;
                }
                //var postWeather;
                var postETag;
                if (post.ETag) {
                  var imgElementSrc =
                    "https://playtime-images.s3.us-east-2.amazonaws.com/" +
                    post.ETag;
                  postETag = (
                    <PhotoView key={key} src={imgElementSrc}>
                      <img
                        className="post-sm-photo"
                        alt=""
                        src={imgElementSrc}
                      />
                    </PhotoView>
                  );
                } else {
                  postETag = <></>;
                }
                //post.weather ? postWeather = post.weather : postWeather = "-";
                var postChr = post.name.substring(0, 1);
                if (post.avatar !== "") {
                  if (
                    post.avatar?.includes(".") ||
                    post.avatar?.includes("/")
                  ) {
                    postChr = (
                      <img
                        className="post_name_avatar"
                        alt={post.name.substring(0, 1)}
                        src={post.avatar}
                      />
                    );
                  }
                }
                if (
                  prevPost.name === post.name &&
                  nextPost.name === post.name
                ) {
                  if (
                    prevPost.avatar === post.avatar &&
                    nextPost.avatar === post.avatar
                  ) {
                    postingName = (
                      <div title={post.name} className="post-name-spacer">
                        {postChr}
                      </div>
                    );
                    postCardDiv = "post-card-mid";
                  } else if (nextPost.avatar === post.avatar) {
                    postingName = (
                      <div title={post.name} className="post-name-spacer">
                        {postChr}
                      </div>
                    );
                    postCardDiv = "post-card-start";
                  } else {
                    postingName = (
                      <div
                        title={post.name}
                        onClick={() => handleNameClick(elements[key])}
                        className="post-name"
                      >
                        {postChr}
                      </div>
                    );
                    postCardDiv = "post-card-end";
                  }
                } else if (prevPost.name === post.name) {
                  if (prevPost.avatar === post.avatar) {
                    postingName = (
                      <div
                        title={post.name}
                        onClick={() => handleNameClick(elements[key])}
                        className="post-name"
                      >
                        {postChr}
                      </div>
                    );
                    postCardDiv = "post-card-end";
                  } else {
                    postingName = (
                      <div
                        title={post.name}
                        onClick={() => handleNameClick(elements[key])}
                        className="post-name"
                      >
                        {postChr}
                      </div>
                    );
                    postCardDiv = "post-card";
                  }
                  //prevPost = post.name;
                } else if (nextPost.name === post.name) {
                  if (nextPost.avatar === post.avatar) {
                    postingName = (
                      <div title={post.name} className="post-name-spacer">
                        {postChr}
                      </div>
                    );
                    postCardDiv = "post-card-start";
                  } else {
                    postingName = (
                      <div
                        title={post.name}
                        onClick={() => handleNameClick(elements[key])}
                        className="post-name"
                      >
                        {postChr}
                      </div>
                    );
                    postCardDiv = "post-card";
                  }
                  //prevPost = post.name;
                } else {
                  postingName = (
                    <div
                      title={post.name}
                      onClick={() => handleNameClick(elements[key])}
                      className="post-name"
                    >
                      {postChr}
                    </div>
                  );
                  postCardDiv = "post-card";
                }
                return (
                  <>
                    <div className="post-card-wrapper">
                      {postingName}
                      <div className={postCardDiv} id={post._id} key={post._id}>
                        <div className="post-body">
                          {postETag}
                          {postBody}
                        </div>
                        <div className="postMenuBtn">
                          <div className="post-meta-data">
                            <span className="post-dt">{postDT}</span>
                          </div>
                          <PostMenu
                            ref={pbRef}
                            post={post._id}
                            weather={post}
                            table={tblName}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}

              <div id="spacer">&nbsp;</div>
            </div>
          </PhotoProvider>

          <div className="add-post-container">
            <ScrollButton />
            <div id="myWeather">
              <Weather lat={lat} long={long} />
            </div>
            <IconContext.Provider value={{}}>
              <div id="input-container">
                {createInputNameBlock(user.picture)}
                <textarea
                  title="Message"
                  rows={1}
                  //type="text"
                  placeholder="comments..."
                  className="inpBody"
                  id="txtMsg"
                  onChange={handleBodyInput}
                  onKeyUp={handleEnterKey}
                />
                <div
                  title="Send"
                  className="hideSendBtn"
                  id="btnSend"
                  onClick={handleSubmit}
                >
                  <BiSend />
                </div>
                <FilePicker isImage={isImage} />
              </div>
            </IconContext.Provider>
          </div>
          <PBBottom />
        </>
      ) : null}
    </>
  );
};

export default Comments;
